const textFieldFormCompany = {
  name: 'Razão Social',
  tradingName: 'Nome Fantasia',
  cnpj: 'CNPJ',
  email: 'E-mail',
  accountable: 'Responsável',
  phone: 'Telefones de contato',
  
};

export default textFieldFormCompany;
